const appEnv = {
  PUB_MODE: "v3-prod",
  PUB_AUTH_MFA_ENABLED: true,
  PUB_AUTH_ENDPOINT: "https://api.dataupload.publicserviceplatform.com/auth/v3",
  PUB_IDENTITY_POOL_ID: "ap-northeast-1:33a5692a-8f14-453a-87c4-b299c054f128",
  PUB_AUTHORIZATION_AUTH_ENDPOINT: "https://api.dataupload.publicserviceplatform.com/auth/v3",
  PUB_USER_POOL_ID: "ap-northeast-1_xxxxxxxxx",
  PUB_CLIENT_ID: "xxxxxxxxxxxxxxxxxxxxxxxx",
  PUB_USER_POOL_ID_WITH_MFA: "ap-northeast-1_y6Uu6sihW",
  PUB_CLIENT_ID_WITH_MFA: "39ni4rvestb5o0s3kc0meg9aki",
  PUB_DUP_AUTH_MFA_ENABLED: true,
  PUB_DUP_AUTH_ENDPOINT: "https://api.dataupload.publicserviceplatform.com/dupauth/v3",
  PUB_DUP_IDENTITY_POOL_ID: "ap-northeast-1:e6d61a29-6e3e-4d85-8430-39a22dad45a9",
  PUB_DUP_AUTHORIZATION_AUTH_ENDPOINT: "https://api.dataupload.publicserviceplatform.com/dupauth/v3",
  PUB_DUP_USER_POOL_ID: "ap-northeast-1_clQHW4jju",
  PUB_DUP_CLIENT_ID: "3aqpvaib960c79qr8svqdop0i2",
  PUB_DUP_USER_POOL_ID_WITH_MFA: "ap-northeast-1_gus0h6IoI",
  PUB_DUP_CLIENT_ID_WITH_MFA: "e93jttdr1b6mpsqs0ut0idce1",
  PUB_API_GATEWAY_ENDPOINT_DUP: "https://api.dataupload.publicserviceplatform.com/dup/v3",
  PUB_API_GATEWAY_ENDPOINT_COMMON: "https://api.dataupload.publicserviceplatform.com/cmn/v3",
  PUB_API_GATEWAY_ENDPOINT_OPERATION: "https://api.dataupload.publicserviceplatform.com/ope/v3",
  PUB_API_GATEWAY_ENDPOINT_PROPSCR: "https://property-tax-screening.publicserviceplatform.com",
  PUB_CONTENTS_BUCKET: "disaster-dup-upload-v3-prod",
  PUB_S3_BUCKET_ENDPOINT: null
};

export default appEnv;
